import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/termos-de-uso')({
  component: TermosDeUsoPage,
});

function TermosDeUsoPage() {
  return (
    <div className="min-h-screen bg-page-background p-6 md:p-10">
      <div className="mx-auto max-w-5xl rounded-lg border bg-card p-6 md:p-10">
        <header className="mb-8 space-y-2 border-b pb-6">
          <h1 className="text-3xl font-bold">ASSETO</h1>
          <p className="text-sm text-muted-foreground">Plataforma de Gestao e Comunicacao para Empresas</p>
          <h2 className="text-xl font-semibold">Termos de Uso</h2>
          <p className="text-sm text-muted-foreground">
            Versao: 1.0 | Vigencia: 01 de junho de 2026
          </p>
          <p className="text-sm text-muted-foreground">
            Ao acessar ou utilizar a plataforma Asseto, voce concorda com os presentes Termos de
            Uso. Leia-os atentamente antes de utilizar nossos servicos.
          </p>
        </header>

        <main className="space-y-8 text-sm leading-7">
          <section className="space-y-3">
            <h3 className="text-lg font-semibold">1. Sobre o Asseto</h3>
            <p>
              O Asseto e uma plataforma SaaS (Software as a Service) desenvolvida e operada pela
              Digital Fluxo, com sede em Belem, Para, Brasil. A plataforma oferece ferramentas de
              gestao operacional e comunicacao para empresas, incluindo modulos de gestao de
              ativos, tarefas, equipes, documentos e integracao com canais de mensagens (Facebook
              Messenger, Instagram e WhatsApp Business).
            </p>
            <p>
              Contato: contato@digitalfluxo.com
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">2. Aceitacao dos Termos</h3>
            <p>
              Ao criar uma conta, acessar ou utilizar qualquer funcionalidade do Asseto, o usuario
              e a empresa contratante (doravante "Cliente") declaram ter lido, compreendido e
              concordado integralmente com estes Termos de Uso e com a{' '}
              <Link to="/politica-privacidade" className="underline text-primary">
                Politica de Privacidade
              </Link>{' '}
              do Asseto.
            </p>
            <p>
              Caso nao concorde com qualquer disposicao destes Termos, o usuario deve cessar
              imediatamente o uso da plataforma.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">3. Cadastro e Conta</h3>
            <p>
              Para utilizar o Asseto, e necessario que o Cliente realize o cadastro da empresa e
              dos usuarios que terao acesso a plataforma. O Cliente e responsavel por:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Fornecer informacoes verdadeiras, precisas e atualizadas no cadastro</li>
              <li>Manter a confidencialidade das credenciais de acesso de seus usuarios</li>
              <li>Todas as acoes realizadas por usuarios vinculados a sua conta</li>
              <li>Notificar imediatamente o Asseto em caso de uso nao autorizado da conta</li>
            </ul>
            <p>
              O Asseto reserva-se o direito de suspender ou encerrar contas que violem estes
              Termos ou que apresentem informacoes falsas.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">4. Planos, Assinaturas e Pagamentos</h3>
            <p>
              O Asseto e oferecido em regime de assinatura, com planos e funcionalidades
              definidos no momento da contratacao. As condicoes comerciais especificas (valores,
              periodicidade e formas de pagamento) sao estabelecidas no contrato firmado entre o
              Cliente e a Digital Fluxo.
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>O nao pagamento dentro do prazo pode resultar na suspensao do acesso</li>
              <li>Add-ons e modulos adicionais estao sujeitos a cobrancas extras conforme o plano</li>
              <li>Reembolsos seguem a politica contratual vigente</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">5. Integracao com Plataformas de Terceiros</h3>

            <h4 className="font-semibold">5.1 Meta (Facebook, Instagram e WhatsApp Business)</h4>
            <p>
              O Asseto oferece integracao opcional com as APIs da Meta Platforms, Inc., permitindo
              que o Cliente gerencie mensagens do Facebook Messenger, Instagram e WhatsApp Business
              dentro da plataforma. Ao ativar essa integracao, o Cliente concorda que:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>
                A integracao e realizada por meio de autorizacao OAuth oficial da Meta — o Asseto
                nunca acessa senhas das contas Meta do Cliente
              </li>
              <li>
                O Cliente e o unico responsavel pelo conteudo das mensagens enviadas e recebidas
                por meio de seus canais Meta conectados ao Asseto
              </li>
              <li>
                O uso dos canais Meta deve estar em conformidade com as{' '}
                <a
                  href="https://www.facebook.com/policies"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline text-primary"
                >
                  Politicas da Meta
                </a>
                , incluindo as regras de mensagens comerciais do WhatsApp Business e as politicas
                de conteudo do Facebook e Instagram
              </li>
              <li>
                O Asseto nao e responsavel por interrupcoes, limitacoes ou mudancas nas APIs da
                Meta que afetem o funcionamento da integracao
              </li>
              <li>
                O Cliente pode revogar o acesso do Asseto a seus canais Meta a qualquer momento,
                conforme descrito na{' '}
                <Link to="/politica-privacidade" className="underline text-primary">
                  Politica de Privacidade
                </Link>
              </li>
            </ul>

            <h4 className="font-semibold">5.2 Outras Integracoes</h4>
            <p>
              O Asseto pode oferecer integracoes com outros servicos de terceiros (Google
              Workspace, Notion, Mattermost, entre outros). O uso dessas integracoes esta sujeito
              tambem aos termos e politicas dos respectivos provedores. O Asseto nao se
              responsabiliza por falhas, mudancas de API ou descontinuacao de servicos de
              terceiros.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">6. Uso Aceitavel</h3>
            <p>E vedado ao Cliente e a seus usuarios:</p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Utilizar o Asseto para fins ilegais, fraudulentos ou que violem direitos de terceiros</li>
              <li>Enviar spam, mensagens nao solicitadas ou conteudo abusivo por meio dos canais integrados</li>
              <li>Tentar acessar sistemas, dados ou contas de outros clientes do Asseto</li>
              <li>Realizar engenharia reversa, descompilar ou tentar extrair o codigo-fonte da plataforma</li>
              <li>Sobrecarregar intencionalmente a infraestrutura do Asseto (ataques de negacao de servico)</li>
              <li>Utilizar a plataforma para armazenar ou transmitir malware ou conteudo malicioso</li>
              <li>Violar as politicas de uso das plataformas integradas (Meta, Google, etc.)</li>
            </ul>
            <p>
              O descumprimento dessas regras pode resultar na suspensao imediata da conta sem
              direito a reembolso.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">7. Propriedade Intelectual</h3>
            <p>
              Todo o conteudo da plataforma Asseto — incluindo interface, codigo, marca, logotipos
              e documentacao — e propriedade exclusiva da Digital Fluxo e protegido pela legislacao
              de propriedade intelectual brasileira.
            </p>
            <p>
              Os dados inseridos pelo Cliente na plataforma (mensagens, arquivos, informacoes de
              usuarios) permanecem de propriedade do Cliente. O Asseto nao reivindica propriedade
              sobre o conteudo gerado pelos Clientes.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">8. Disponibilidade e Manutencao</h3>
            <p>
              O Asseto emprega esforcos razoaveis para manter a plataforma disponivel 24 horas
              por dia, 7 dias por semana. No entanto, nao garantimos disponibilidade ininterrupta.
              Podem ocorrer interrupcoes por:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Manutencao programada (com aviso previo sempre que possivel)</li>
              <li>Falhas de infraestrutura ou de terceiros (hospedagem, APIs externas)</li>
              <li>Eventos fora do controle do Asseto (force majeure)</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">9. Limitacao de Responsabilidade</h3>
            <p>
              Na maxima extensao permitida pela legislacao aplicavel, o Asseto nao sera
              responsavel por:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>Danos indiretos, incidentais ou consequentes decorrentes do uso da plataforma</li>
              <li>Perda de dados causada por falha do Cliente em manter backups adequados</li>
              <li>Acoes ou omissoes de plataformas de terceiros integradas ao Asseto</li>
              <li>Conteudo enviado ou recebido pelos canais de mensagem do Cliente</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">10. Privacidade e Protecao de Dados</h3>
            <p>
              O tratamento de dados pessoais pelo Asseto e regido pela{' '}
              <Link to="/politica-privacidade" className="underline text-primary">
                Politica de Privacidade
              </Link>
              , que integra estes Termos de Uso por referencia. O Asseto opera em conformidade
              com a Lei Geral de Protecao de Dados (LGPD — Lei n.º 13.709/2018).
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">11. Rescisao</h3>
            <p>
              Qualquer das partes pode encerrar a relacao contratual conforme os termos do contrato
              de assinatura. Apos o encerramento:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>O acesso a plataforma sera revogado</li>
              <li>Os dados do Cliente serao retidos pelo prazo previsto na Politica de Privacidade e entao excluidos</li>
              <li>As integracoes com plataformas de terceiros serao automaticamente desconectadas</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">12. Alteracoes nos Termos</h3>
            <p>
              O Asseto pode atualizar estes Termos periodicamente. Alteracoes relevantes serao
              comunicadas com pelo menos 15 dias de antecedencia por e-mail ou notificacao dentro
              da plataforma. O uso continuado apos a vigencia das alteracoes implica aceitacao dos
              novos Termos.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">13. Lei Aplicavel e Foro</h3>
            <p>
              Estes Termos sao regidos pela legislacao brasileira. Qualquer controversia sera
              submetida ao foro da comarca de Belem, Estado do Para, com exclusao de qualquer
              outro, por mais privilegiado que seja.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold">14. Contato</h3>
            <p>
              Duvidas sobre estes Termos de Uso podem ser enviadas para:{' '}
              <a href="mailto:contato@digitalfluxo.com" className="underline text-primary">
                contato@digitalfluxo.com
              </a>
            </p>
          </section>
        </main>

        <footer className="mt-10 border-t pt-6 text-sm text-muted-foreground">
          <p>Asseto — Digital Fluxo | Versao 1.0 | Vigencia: 01 de junho de 2026</p>
          <div className="mt-4 flex gap-4">
            <Link to="/politica-privacidade" className="underline">Politica de Privacidade</Link>
            <Link to="/politica-cookie" className="underline">Politica de Cookies</Link>
            <Link to="/exclusao-de-dados" className="underline">Exclusao de Dados</Link>
          </div>
        </footer>
      </div>
    </div>
  );
}
